var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import { StringFormat } from './string';

var StringImageTextFormat = function (_super) {
  __extends(StringImageTextFormat, _super);

  function StringImageTextFormat() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * 将数据格式化为 number 类型的值
   */


  StringImageTextFormat.prototype.format = function (value) {
    var stringValue = _super.prototype.format.call(this, value);

    return stringValue.trim();
  };

  return StringImageTextFormat;
}(StringFormat);

export { StringImageTextFormat };